<script setup lang="ts">
import { computed } from 'vue';
import type { TLlmTechnicalDetails } from '@/_core/entities/vulnerability/models/types';

const props = defineProps<{
  technicalDetails: TLlmTechnicalDetails | null;
}>();

const summaryText = computed(() => props.technicalDetails?.summary ?? null);
</script>

<template>
  <div v-if="summaryText" class="tw:typography-small tw:text-secondary">
    {{ summaryText }}
  </div>
</template>
